import { render, staticRenderFns } from "./TotalUsers.vue?vue&type=template&id=28603147&"
import script from "./TotalUsers.vue?vue&type=script&lang=js&"
export * from "./TotalUsers.vue?vue&type=script&lang=js&"
import style0 from "./TotalUsers.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports